var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var u = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var u in e) {
      r.d(n, u, function (t) {
        return e[t];
      }.bind(null, u));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 79);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  79: function _(e, t, r) {
    "use strict";

    var n = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    },
        u = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = n(r(1)),
        o = n(r(2)),
        i = u(r(80)),
        a = r(4),
        c = o.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))),
        f = o.default.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
      var e = _ref.theme;
      return e.label;
    }),
        s = o.default.input.attrs(function () {
      return {
        type: "checkbox"
      };
    })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  &:checked + .slider {\n    ", ";\n  }\n"])), function (_ref2) {
      var e = _ref2.theme;
      return e.input;
    }, function (_ref3) {
      var e = _ref3.theme;
      return e.activeSlider;
    }),
        d = o.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
      var e = _ref4.theme;
      return e.slider;
    });

    t.default = function (_ref5) {
      var e = _ref5.enabled,
          _ref5$theme = _ref5.theme,
          t = _ref5$theme === void 0 ? "Themeless" : _ref5$theme,
          r = _ref5.onChange;

      var _l$useState = l.useState(e),
          _l$useState2 = _slicedToArray(_l$useState, 2),
          n = _l$useState2[0],
          u = _l$useState2[1];

      return l.useEffect(function () {
        u(e);
      }, [e]), l.default.createElement(o.ThemeProvider, {
        theme: a.isObject(t) ? t : i.default[t]
      }, l.default.createElement(c, {
        className: "lego-switcher"
      }, l.default.createElement(f, {
        className: "switch"
      }, l.default.createElement(s, {
        type: "checkbox",
        checked: n,
        onChange: function onChange() {
          u(!n), r(!n);
        }
      }), l.default.createElement(d, {
        className: "slider"
      }))));
    };
  },
  80: function _(e, t) {
    e.exports = require("../../themes/Switcher.theme");
  }
});